import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useAccount } from "wagmi";

import { ContractFeatures, type IToken } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { useCheckTokenOwnership } from "../../../../../utils/use-check-token-ownership";
import { GradeButton } from "../../../../../components/buttons";
import { AllowanceInfoPopover } from "../../../../../components/dialogs/allowance";
import { TokenDiscreteView } from "./discrete";
import { StyledToolbar } from "./styled";

export interface IDiscreteTokenPanelProps {
  token: IToken;
}

export const DiscreteTokenPanel = (props: IDiscreteTokenPanelProps) => {
  const { token } = props;

  const { address: account } = useAccount();
  const { checkTokenOwnership } = useCheckTokenOwnership();

  const [hasOwnership, setHasOwnership] = useState(false);

  useEffect(() => {
    if (token.id && account) {
      void checkTokenOwnership(void 0, {
        account,
        tokenId: token.id,
      })
        .then((json: { hasOwnership: boolean }) => {
          setHasOwnership(json?.hasOwnership);
        })
        .catch(console.error);
    }
  }, [account, token]);

  if (!token.template?.contract?.contractFeatures.includes(ContractFeatures.DISCRETE)) {
    return null;
  }

  return (
    <Card>
      <Card.Content>
        <StyledToolbar disableGutters>
          <Typography variant="h5" component="p">
            <FormattedMessage id="pages.token.attributes" />
          </Typography>
          <AllowanceInfoPopover />
        </StyledToolbar>
        <TokenDiscreteView metadata={token.metadata} />
      </Card.Content>
      <Card.Footer>
        <GradeButton token={token} disabled={!hasOwnership} />
      </Card.Footer>
    </Card>
  );
};
